import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ activeTab, setActiveTab }) => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Synchroniser l'onglet actif avec l'URL
  useEffect(() => {
    const path = location.pathname;

    if (path === '/') {
      setActiveTab('accueil');
    } else if (path === '/services') {
      setActiveTab('services');
    } else if (path === '/realisations') {
      setActiveTab('realisations');
    } else if (path === '/about') {
      setActiveTab('apropos');
    }
  }, [location.pathname, setActiveTab]);

  return (
    <header className="bg-[#2D2A5D] text-white sticky top-0 z-50 shadow-md">
      <div className="mx-auto max-w-full px-9 lg:px-28 py-4 flex items-center justify-between">
        {/* Titre EDMF */}
        <div className="flex items-center">
          <div className="text-4xl font-bold tracking-tighter">
            <span className="text-white">EDMF</span>
          </div>
          <div className="ml-2 text-sm hidden md:block">
            <div>Ets Doudou MENDY & FILS</div>
          </div>
        </div>

        {/* Menu desktop */}
        <nav className="hidden md:flex items-center space-x-6">
          <Link
            to="/"
            onClick={() => setActiveTab('accueil')}
            className={`text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === 'accueil' ? 'border-b-2 border-red-500' : ''
            }`}
          >
            Accueil
          </Link>
          <Link
            to="/services"
            onClick={() => setActiveTab('services')}
            className={`text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === 'services' ? 'border-b-2 border-red-500' : ''
            }`}
          >
            Services
          </Link>
          <Link
            to="/realisations"
            onClick={() => setActiveTab('realisations')}
            className={`text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === 'realisations' ? 'border-b-2 border-red-500' : ''
            }`}
          >
            Réalisations
          </Link>
          <Link
            to="/about"
            onClick={() => setActiveTab('apropos')}
            className={`text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === 'apropos' ? 'border-b-2 border-red-500' : ''
            }`}
          >
            À Propos
          </Link>
          <Link
            to="/#contact"
            className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg text-white font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            Contact
          </Link>
        </nav>

        {/* Hamburger Button */}
        <button
          className="md:hidden text-white focus:outline-none z-50"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Menu mobile */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-[#2D2A5D] text-white transform ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        } transition-transform duration-300 ease-in-out z-40 md:hidden`}
      >
        <nav className="flex flex-col p-6 space-y-6">
          <Link
            to="/"
            onClick={() => {
              setActiveTab('accueil');
              setIsMenuOpen(false);
            }}
            className={`hover:text-red-500 transition-colors ${
              activeTab === 'accueil' ? 'border-b-2 border-red-500' : ''
            }`}
          >
            Accueil
          </Link>
          <Link
            to="/services"
            onClick={() => {
              setActiveTab('services');
              setIsMenuOpen(false);
            }}
            className={`hover:text-red-500 transition-colors ${
              activeTab === 'services' ? 'border-b-2 border-red-500' : ''
            }`}
          >
            Services
          </Link>
          <Link
            to="/realisations"
            onClick={() => {
              setActiveTab('realisations');
              setIsMenuOpen(false);
            }}
            className={`hover:text-red-500 transition-colors ${
              activeTab === 'realisations' ? 'border-b-2 border-red-500' : ''
            }`}
          >
            Réalisations
          </Link>
          <Link
            to="/about"
            onClick={() => {
              setActiveTab('apropos');
              setIsMenuOpen(false);
            }}
            className={`hover:text-red-500 transition-colors ${
              activeTab === 'apropos' ? 'border-b-2 border-red-500' : ''
            }`}
          >
            À Propos
          </Link>
          <Link
            to="/#contact"
            onClick={() => setIsMenuOpen(false)}
            className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg text-white font-medium transition-colors text-center"
          >
            Contact
          </Link>
        </nav>
      </div>

      {/* Overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setIsMenuOpen(false)}
        ></div>
      )}

      {/* Bandeau avec défilement horizontal sur mobile */}
      <div className="bg-red-600 py-2 overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="hidden md:block text-white text-center md:text-left flex-wrap">
            <span className="mx-2 whitespace-nowrap">ENTRETIEN BATIMENT</span>
            <span className="mx-2 whitespace-nowrap">•</span>
            <span className="mx-2 whitespace-nowrap">PEINTURE</span>
            <span className="mx-2 whitespace-nowrap">•</span>
            <span className="mx-2 whitespace-nowrap">MACONNERIE</span>
            <span className="mx-2 whitespace-nowrap">•</span>
            <span className="mx-2 whitespace-nowrap">ELECTRICITE</span>
            <span className="mx-2 whitespace-nowrap">•</span>
            <span className="mx-2 whitespace-nowrap">ETANCHEITE</span>
            <span className="mx-2 whitespace-nowrap">•</span>
            <span className="mx-2 whitespace-nowrap">CHARPENTE</span>
          </div>

          {/* Texte défilant sur mobile */}
          <div className="md:hidden animate-scroll whitespace-nowrap text-white">
            <span className="inline-block px-4">
              ENTRETIEN BATIMENT • PEINTURE • MACONNERIE • ELECTRICITE • ETANCHEITE • CHARPENTE
            </span>
            <span className="inline-block px-4">
              ENTRETIEN BATIMENT • PEINTURE • MACONNERIE • ELECTRICITE • ETANCHEITE • CHARPENTE
            </span>
          </div>
        </div>
      </div>

      {/* Style pour l’animation de défilement */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
        .animate-scroll {
          animation: scroll 10s linear infinite;
        }
      `}</style>
    </header>
  );
};

export default Header;